import intlLocale from 'shared/core/intlLocale';

function configureHighcharts(Highcharts) {
  Highcharts.setOptions({
    lang: {locale: intlLocale()},
    palette: {colorScheme: 'light'},
    tooltip: {
      backgroundColor: 'rgba(247, 247, 247, 0.85)',
      borderColor: null,
      style: {
        fontSize: '12px',
        whiteSpace: 'nowrap',
        width: 'auto'
      }
    }
  });

  return Highcharts;
}

export default configureHighcharts;
